import LessonHub from "@/components/LessonHub";

const Index = () => {
  return <LessonHub />;
};

export default Index;